import { func, object } from 'prop-types';
import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { HORIZONTAL_ALIGNMENT } from 'hb-builder/constants/alignment';
import { getAlignment } from 'hb-builder/utils/attributes';

import InputTitle from '../SettingsDecoration/InputTitle';

const HorizontalItem = ({ dataTestId, isActive, onClick, type }) => (
  <HStyledItem
    data-testid={dataTestId}
    data-isactive={isActive}
    onClick={onClick}
    $isActive={isActive}
    $type={type}
  >
    <div />
    <div />
    <div />
  </HStyledItem>
);

const HorizontalAlignment = ({ item, onChange, title }) => {
  const [value, setValue] = useState(
    getAlignment(item.attributes?.horizontalAlign),
  );

  useEffect(() => {
    setValue(getAlignment(item.attributes?.horizontalAlign));
  }, [item.attributes?.horizontalAlign]);

  const handleChange = ({ value }) => {
    setValue(value);

    onChange({
      id: item.id,
      values: [
        { settingKey: 'attributes.horizontalAlign', value },
        item.attributes?.left && {
          settingKey: 'attributes.left',
          value: null,
        },
      ].filter(Boolean),
    });
  };

  return (
    <Wrapper>
      <InputTitle
        boxProps={{ mr: 3 }}
        id="horizontal-alignment"
        label={title}
      />
      <WrapperItems>
        {Object.values(HORIZONTAL_ALIGNMENT).map((alignmentValue) => (
          <HorizontalItem
            dataTestId={`builder-settings-alignment-${alignmentValue}`}
            key={alignmentValue}
            isActive={value === alignmentValue}
            onClick={() => handleChange({ value: alignmentValue })}
            type={alignmentValue}
          />
        ))}
      </WrapperItems>
    </Wrapper>
  );
};

export default HorizontalAlignment;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 4,
}))``;

const getAlignmentIcon = ({ $type }) => {
  switch ($type) {
    case 'center':
      return css`
        align-items: center;

        > * {
          &:nth-child(2),
          &:nth-child(3) {
            width: 80%;
          }
        }
      `;

    case 'right':
      return css`
        align-items: flex-end;

        > * {
          &:nth-child(2) {
            width: 80%;
          }

          &:nth-child(3) {
            width: 90%;
          }
        }
      `;

    case 'left':
    default:
      return css`
        > * {
          &:nth-child(2) {
            width: 80%;
          }

          &:nth-child(3) {
            width: 90%;
          }
        }
      `;
  }
};

const HStyledItem = styled(Box).attrs(({ $isActive }) => ({
  bg: $isActive ? 'primary' : 'white',
  flexDirection: 'column',
  height: 28,
  justifyContent: 'center',
  p: 1,
  width: 28,
}))`
  cursor: pointer;
  ${getAlignmentIcon}

  > * {
    background-color: ${({ theme, $isActive }) =>
      $isActive ? theme.colors.white : theme.colors.asphalt};
    height: 2px;
    width: 100%;
  }

  > * + * {
    margin-top: 3px;
  }
`;

const WrapperItems = styled(Box)`
  border-radius: 3px;
  border: ${({ theme }) => `1px solid ${theme.colors.asphalt}`};
  overflow: hidden;

  > * + * {
    border-left: ${({ theme }) => `1px solid ${theme.colors.asphalt}`};
  }
`;

HorizontalAlignment.propTypes = {
  item: object.isRequired,
  onChange: func.isRequired,
};
